import { defineComponent as n, computed as c, openBlock as r, createBlock as p, unref as s } from "vue";
import f from "../assets/icons/chevron-left.svg.mjs";
const u = /* @__PURE__ */ n({
  __name: "chevron-left-icon",
  props: {
    fill: { default: "currentColor" },
    size: { default: "md" }
  },
  setup(e) {
    const l = e, o = {
      sm: "12px",
      md: "16px",
      lg: "24px",
      xl: "32px",
      "2xl": "48px"
    }, t = c(() => o[l.size]);
    return (i, a) => (r(), p(s(f), {
      fill: i.fill,
      width: t.value,
      style: {
        verticalAlign: "middle",
        display: "inline-block",
        height: "auto"
      }
    }, null, 8, ["fill", "width"]));
  }
});
export {
  u as default
};
//# sourceMappingURL=chevron-left-icon.vue.mjs.map
